import React from 'react';
import DevicePage from './DevicePage';

const GatewayPage: React.FC = () => {
  return <DevicePage deviceType="gateway" />;
};

export default GatewayPage;
